import moment from "moment";
import { Col, Row } from "react-bootstrap";
import { withTranslation } from "react-i18next";
import { BsChevronLeft, BsChevronRight } from "react-icons/bs";
import ListaVacia from "../ListaVacia";

function CardHorarioDoctorManual({t, horario, selectTime, indexSelect, days, plusDay, minusDay, startDay}){
    
    return(
        <>
            <Row className="align-items-center">
                <Col xs="2" md="2" className="text-center">{startDay > 0 && <span className="bg-arrow" onClick={e=>minusDay(1)}><BsChevronLeft /></span>}</Col>
                <Col xs="2" md="8" className="text-center">
                    <div className="text-center">
                        <span className="d-block font-weight-bold-600">{moment(horario.key, "YYYY-MM-DD").format("ddd")}</span>
                        <span className="font-size-08rem d-block">{moment(horario.key, "YYYY-MM-DD").format("DD MMM YYYY")}</span>                    
                    </div>
                </Col>
                <Col xs="2" md="2" className="text-center">{startDay !== days && <span className="bg-arrow" onClick={e=>plusDay(1)}><BsChevronRight /></span>}</Col>
            </Row>
            {
                !horario.value.length ? 
                <ListaVacia texto={t('no_hay_disponiblidad')} /> :
                <div className="wrapper-hour mt-3">
                    {
                        horario.value.map((it, i)=>(
                            <div 
                                key={i} 
                                className={`cursor-pointer box-hour ${i===indexSelect && 'box-hour-active'}`}
                                onClick={e=>selectTime(it, i)}
                            >{moment(it, "YYYY-MM-DDTHH:mm:ss").format("HH:mm")}</div>
                        ))
                    }
                </div>
            }            
        </>


        
    )
}

export default withTranslation()(CardHorarioDoctorManual)